
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { BasePoI } from '../backend/backendapi';
import PoiListModal from './PoiListModal';
import GpsTrackerListModal from './gps/GpsTrackerListModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'PageTitleBar',
  components: {
    Autocomplete,
    GpsTrackerListModal,
    PoiListModal,
  },
})
export default class PageTitleBar extends Vue {
  @Prop({ required: true })
  readonly pois!: BasePoI[];

  openGpsTrackerListModal(): void {
    (this.$refs.gpsTrackerListModal! as GpsTrackerListModal).open();
  }

  openPoiListModal(): void {
    (this.$refs.poiListModal! as PoiListModal).open();
  }

  search(input: string): BasePoI[] {
    if (input.length < 1) {
      return [];
    }
    input = input.toLowerCase();
    return this.pois.filter(poi => poi.name?.toLowerCase().startsWith(input));
  }

  getResultValue(result) {
    return result.name;
  }
}
